import { useState } from 'react';
import PropTypes from 'prop-types';
import { Controller, useFormContext } from 'react-hook-form';

import { DatePicker } from '@mui/x-date-pickers/DatePicker';

// ----------------------------------------------------------------------

export default function RHFDatePicker({ name, helperText, type, ...other }) {
  const { control } = useFormContext();
  const [open, setOpen] = useState(false);

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <DatePicker
          {...field}
          format="dd/MM/yyyy"
          open={open}
          onOpen={() => setOpen(true)}
          onClose={() => setOpen(false)}
          {...(() => {
            const { slotProps: otherSlotProps, ...rest } = other || {};
            const mergedSlotProps = {
              ...otherSlotProps,
              textField: {
                fullWidth: true,
                error: !!error,
                helperText: error?.message,
                onClick: () => setOpen(true),
                ...(otherSlotProps?.textField || {}),
              },
            };
            return { slotProps: mergedSlotProps, ...rest };
          })()}
        />
      )}
    />
  );
}

RHFDatePicker.propTypes = {
  helperText: PropTypes.object,
  name: PropTypes.string,
  type: PropTypes.string,
};
